import axios from "axios";

export async function getCoord(props) {
  //   const url = `${process.env.REACT_APP_API_URL}syspro-web-api/v1/get-entity`;
  const url = `https://gongaji-mushaf-service-m3gra3glsq-et.a.run.app/v1/coord/get`;

  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        // headers: headers(),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Version: "V3",
          Authorization: `Bearer ${props.bearertoken}`,
        },
        params: {
          coord_mushaf: props.mushaf.mushaf_code,
          coord_page: props.page.page_id,
          coord_type: props.coord_type.coordt_code,
        },
      })
      .then((response) => {
        console.log("SUCCESS [COORD]");
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        console.log("ERROR [COORD]");
        reject(error);
      });
  });
}

export async function checkCoord(props, bearertoken) {
  //   const url = `${process.env.REACT_APP_API_URL}syspro-web-api/v1/get-entity`;
  const url = `https://gongaji-mushaf-service-m3gra3glsq-et.a.run.app/v1/coord/get`;

  let params = {
    coord_mushaf: props.coord_mushaf.mushaf_code,
    coord_page: props.coord_page.page_id,
    coord_type: props.coord_type.coordt_code,
    type_search: "first",
  };
  const coord_type = props.coord_type.coordt_code;

  if (
    coord_type === "AYAT" ||
    coord_type === "MAQTA" ||
    coord_type === "MAQRA"
  ) {
    params.coord_sequence = props.coord_sequence;
  }

  if (
    coord_type === "AYAT" ||
    coord_type === "AYAT-FIRST" ||
    coord_type === "AYAT-LAST"
  ) {
    params.coord_ayat = props.coord_ayat.ayat_id;
  }

  if (
    coord_type === "MAQTA" ||
    coord_type === "MAQTA-FIRST" ||
    coord_type === "MAQTA-LAST"
  ) {
    params.coord_maqta = props.coord_maqta.maqta_id;
  }

  if (coord_type === "MAQRA") {
    params.coord_maqra = props.coord_maqra.maqra_id;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        // headers: headers(),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Version: "V3",
          Authorization: `Bearer ${bearertoken}`,
        },
        params: params,
      })
      .then((response) => {
        console.log("SUCCESS [COORD]");
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        console.log("ERROR [COORD]");
        reject(error);
      });
  });
}

export async function createCoord(props, bearertoken) {
  //   const url = `${process.env.REACT_APP_API_URL}syspro-web-api/v1/get-entity`;
  const url = `https://gongaji-mushaf-service-m3gra3glsq-et.a.run.app/v1/coord/set`;
  // const url = `http://localhost:8080/v1/coord/set`;

  let params = {
    coord_mushaf: props.coord_mushaf.mushaf_code,
    coord_page: parseInt(props.coord_page.page_id),
    coord_type: props.coord_type.coordt_code,
    coord_left: parseFloat(props.coord_left_percentage),
    coord_right: parseFloat(props.coord_right_percentage),
    coord_top: parseFloat(props.coord_top_percentage),
    coord_bottom: parseFloat(props.coord_bottom_percentage),
    coord_width: parseFloat(
      props.coord_right_percentage - props.coord_left_percentage
    ),
    coord_height: parseFloat(
      props.coord_bottom_percentage - props.coord_top_percentage
    ),
    coord_aspect_ratio: parseFloat(props.coord_aspect_ratio),
  };
  const coord_type = props.coord_type.coordt_code;

  if (
    coord_type === "AYAT" ||
    coord_type === "MAQTA" ||
    coord_type === "MAQTA-BODY" ||
    coord_type === "MAQRA"
  ) {
    params.coord_sequence = parseInt(props.coord_sequence);
  }

  if (
    coord_type === "AYAT" ||
    coord_type === "AYAT-FIRST" ||
    coord_type === "AYAT-LAST"
  ) {
    params.coord_ayat = parseInt(props.coord_ayat.ayat_id);
  }

  if (
    coord_type === "MAQTA" ||
    coord_type === "MAQTA-FIRST" ||
    coord_type === "MAQTA-LAST" ||
    coord_type === "MAQTA-BODY"
  ) {
    params.coord_maqta = parseInt(props.coord_maqta.maqta_id);
  }

  if (coord_type === "MAQRA") {
    params.coord_maqra = parseInt(props.coord_maqra.maqra_id);
  }

  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        // headers: headers(),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Version: "V3",
          Authorization: `Bearer ${bearertoken}`,
        },
      })
      .then((response) => {
        console.log("SUCCESS [COORD]");
        resolve(response.data);
      })
      .catch((error) => {
        if (error.response.data) {
          console.log(error.response.data);
          resolve(error.response.data);
        } else {
          console.error("Error fetching data:", error.message);
          reject(error);
        }
      });
  });
}

export async function deleteCoord(props, bearertoken) {
  //   const url = `${process.env.REACT_APP_API_URL}syspro-web-api/v1/get-entity`;
  const url = `https://gongaji-mushaf-service-m3gra3glsq-et.a.run.app/v1/coord/delete`;
  // const url = `http://localhost:8080/v1/coord/set`;

  let params = {
    coord_mushaf: props.coord_mushaf.mushaf_code,
    coord_page: parseInt(props.coord_page.page_id),
    coord_type: props.coord_type.coordt_code,
    // coord_left: parseFloat(props.coord_left_percentage),
    // coord_right: parseFloat(props.coord_right_percentage),
    // coord_top: parseFloat(props.coord_top_percentage),
    // coord_bottom: parseFloat(props.coord_bottom_percentage),
    // coord_width: parseFloat(
    //   props.coord_right_percentage - props.coord_left_percentage
    // ),
    // coord_height: parseFloat(
    //   props.coord_bottom_percentage - props.coord_top_percentage
    // ),
    // coord_aspect_ratio: parseFloat(props.coord_aspect_ratio),
  };
  const coord_type = props.coord_type.coordt_code;

  if (
    coord_type === "AYAT" ||
    coord_type === "MAQTA" ||
    coord_type === "MAQTA-BODY" ||
    coord_type === "MAQRA"
  ) {
    params.coord_sequence = parseInt(props.coord_sequence);
  }

  if (
    coord_type === "AYAT" ||
    coord_type === "AYAT-FIRST" ||
    coord_type === "AYAT-LAST"
  ) {
    params.coord_ayat = parseInt(props.coord_ayat.ayat_id);
  }

  if (
    coord_type === "MAQTA" ||
    coord_type === "MAQTA-FIRST" ||
    coord_type === "MAQTA-LAST" ||
    coord_type === "MAQTA-BODY"
  ) {
    params.coord_maqta = parseInt(props.coord_maqta.maqta_id);
  }

  if (coord_type === "MAQRA") {
    params.coord_maqra = parseInt(props.coord_maqra.maqra_id);
  }

  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        // headers: headers(),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Version: "V3",
          Authorization: `Bearer ${bearertoken}`,
        },
      })
      .then((response) => {
        console.log("SUCCESS DELETE [COORD]");
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        console.log("ERROR DELETE [COORD]");
        reject(error);
      });
  });
}
